// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.TimeRangeModal_list__zT\\+e6 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.TimeRangeModal_list-item-container__mGRHm {
  width: 100%;
  max-width: 40rem;
}

.TimeRangeModal_add-button__\\+c\\+Wf {
  display: flex;
  height: 3rem;
  width: 100%;
  max-width: 40rem;
  background: #f2f2f2;
  justify-content: center;
  align-items: center;
}
.TimeRangeModal_add-button__\\+c\\+Wf img {
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
}

.TimeRangeModal_add-button__\\+c\\+Wf:hover {
  background: #eeeeee;
}

hr {
  width: 100%;
}

.TimeRangeModal_header__rAzfa {
  display: flex;
  width: 100%;
  padding-top: 0.5rem;
}

.TimeRangeModal_timezone__eaNjS {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/NodeInfo/TimeRangeModal/TimeRangeModal.module.scss","webpack://./src/utils/_utils.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;AEzBA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AD/BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAsBF;;AAnBA;EACE,WAAA;EACA,gBAAA;AAsBF;;AAnBA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EAEA,uBAAA;EACA,mBAAA;AAqBF;AAnBE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AAqBJ;;AAjBA;EACE,mBAAA;AAoBF;;AAjBA;EACE,WAAA;AAoBF;;AAjBA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAoBF;;AAjBA;EACE,iBAAA;AAoBF","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.list {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.list-item-container {\n  width: 100%;\n  max-width: 40rem;\n}\n\n.add-button {\n  display: flex;\n  height: 3rem;\n  width: 100%;\n  max-width: 40rem;\n  background: #f2f2f2;\n  justify-content: center;\n  align-items: center;\n}\n.add-button img {\n  width: 2rem;\n  height: 2rem;\n  margin-right: 0.5rem;\n}\n\n.add-button:hover {\n  background: #eeeeee;\n}\n\nhr {\n  width: 100%;\n}\n\n.header {\n  display: flex;\n  width: 100%;\n  padding-top: 0.5rem;\n}\n\n.timezone {\n  margin-left: auto;\n}",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `TimeRangeModal_list__zT+e6`,
	"list-item-container": `TimeRangeModal_list-item-container__mGRHm`,
	"add-button": `TimeRangeModal_add-button__+c+Wf`,
	"header": `TimeRangeModal_header__rAzfa`,
	"timezone": `TimeRangeModal_timezone__eaNjS`
};
export default ___CSS_LOADER_EXPORT___;
